import { createContext, ReactNode, useEffect, useState } from 'react';
import { TonClient } from '@ton/ton';
import { getHttpEndpoint } from '@orbs-network/ton-access';

type TonClientContextProviderValue = {
  tonClient: TonClient | undefined;
};

const initialContext = {
  tonClient: undefined,
};

export const TonClientContext = createContext<TonClientContextProviderValue>(initialContext);

export const TonClientProvider = ({ children }: { children: ReactNode }) => {
  const [client, setClient] = useState<TonClient | undefined>(undefined);

  useEffect(() => {
    const initialize = async () => {
      try {
        const endpoint = await getHttpEndpoint({
          network: 'testnet',
        });

        const tonClient = new TonClient({ endpoint });
        setClient(tonClient);
      } catch (error) {
        console.error('Failed to initialize TonClient:', error);
      }
    };

    initialize();
  }, []);

  return (
    <TonClientContext.Provider value={{ tonClient: client }}>{children}</TonClientContext.Provider>
  );
};
